import React, { useEffect, useState } from 'react';

import { Badge, Box, TableSortLabel } from '@mui/material';
import { visuallyHidden } from '@mui/utils';

import CurrentTableContext from 'components/shared/CustomTable/context';

import { Column } from 'api/shared/models';

interface Props {
  column: Column;
}

const MultipleSort = ({ column }: Props) => {
  const { sortColumns, handleUpdateSortColumnByApiField } =
    React.useContext(CurrentTableContext);

  const [sortColumn, setSortColumn] = useState<Column | null | undefined>(null);
  const [orderSort, setOrderSort] = useState(0);

  const createSortHandler = (property: string) => {
    handleUpdateSortColumnByApiField(property);
  };

  useEffect(() => {
    setSortColumn(sortColumns.find((c) => c.apiField === column.apiField));
    setOrderSort(
      sortColumns.findIndex((c) => c.apiField === column.apiField) + 1,
    );
  }, [column, sortColumns]);

  if (sortColumn) {
    return (
      <Box display="inline-block" marginRight={1}>
        <Badge
          badgeContent={orderSort}
          color="primary"
          sx={{
            zIndex: 99999999,
          }}
        >
          <TableSortLabel
            active={true}
            direction={(sortColumn.direction || 'asc') as 'asc' | 'desc'}
            onClick={() => createSortHandler(sortColumn.apiField)}
          >
            <Box component="span" sx={visuallyHidden}>
              {sortColumn.direction === 'desc'
                ? 'sorted descending'
                : 'sorted ascending'}
            </Box>
          </TableSortLabel>
        </Badge>
      </Box>
    );
  }

  return null;
};

export default MultipleSort;
